import { render, staticRenderFns } from "./ModifiedColumn.vue?vue&type=template&id=3c1a0c1e&"
import script from "./ModifiedColumn.vue?vue&type=script&lang=js&"
export * from "./ModifiedColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import OlTooltip from '@/components/oluetify/OlTooltip.vue'
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {OlTooltip,VIcon})
